export class TranslationMediaView {
    public no: number;
    public mediaId: string;
    public mediaName: string;
    public mediaTypeCode: string;
    public mediaTypeName: string;
    public mediaContentId: string;
    public mediaFile: File;
    public mediaFileBase64: any;
    public mediaFilePreview: File;
    public mediaFilePreviewBase64: any;
    public mediaFileNotFound: boolean;
    public fileChange: boolean;
    public noFile: boolean;
}